export enum MetaMaskError {
    rejected = 'User rejected the request',
    denied = 'User denied transaction signature',
    reverted = 'Transaction has been reverted by the EVM',
}

